import React from 'react';
import { Segmented } from 'antd';
import { useTheme } from '../../../../../../../../utils/modules/theme/ThemeProvider';
import './styles.css';

interface FileTypeSegmentedProps {
    value: number | undefined;
    onChange: (value: number) => void;
    className?: string;
}

const FileTypeSegmented: React.FC<FileTypeSegmentedProps> = ({
    value,
    onChange,
    className = '',
}) => {
    const { theme } = useTheme();
    const themeClass = theme === 'dark' ? 'file-type-segmented-dark' : 'file-type-segmented-light';

    const options = [
        { label: 'Все', value: 0 },
        { label: 'Видео', value: 1 },
        { label: 'Фото', value: 2 },
        { label: 'Аудио', value: 3 },
    ];

    const handleChange = (newValue: string | number) => {
        onChange(Number(newValue));
    };

    return (
        <div className={`file-type-segmented ${themeClass} ${className}`}>
            <label className="file-type-segmented-label title medium">
                Тип файла
            </label>
            <Segmented
                value={value ?? 0}
                onChange={handleChange}
                options={options}
                className="file-type-segmented-control"
                size="middle"
            />
        </div>
    );
};

export default FileTypeSegmented; 